import { getAjaxConfig, IAjaxResponse } from "../../api";
import { HttpService } from "../../packages/HttpService";

export const businessConsult = (requestBody: any) => {
    return HttpService.get<IAjaxResponse<any>>(
      `/api/biz/partner`,
      requestBody,
      getAjaxConfig(),
    );
};